import { render, staticRenderFns } from "./SocialMediaCard.vue?vue&type=template&id=60579ffa&scoped=true&"
import script from "./SocialMediaCard.vue?vue&type=script&lang=js&"
export * from "./SocialMediaCard.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaCard.vue?vue&type=style&index=0&id=60579ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60579ffa",
  null
  
)

export default component.exports